// extracted by mini-css-extract-plugin
export default {"link":"_0h94TMlYuPTs327UJFq+Rg=="};